import React from 'react';
import * as MUI from '@material-ui/core';
import { useStyles } from './styles';

export const GlobalCategoryRow = ({ children, ...props }) => {
  const classes = useStyles(props);

  return (
    <MUI.Box className={classes.globalCategoryRow}>
      {children}
    </MUI.Box>
  );
}

export default GlobalCategoryRow;
